import { Injectable } from '@angular/core';

import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class CheckCacheRepository extends MemoryMapCacheRepository<boolean> {
    getKey(id: string): string {
        return 'CheckCacheRepository' + String(id);
    }
}
